export default __webpack_public_path__ + "static/media/smart_assistant_avatar_white_2.2b0aef66.png";